import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { leadSourceFilterOptions } from '@new/__global/constants/filter'

import { FiltersSharedProps } from './Filters.types'

interface LeadSourceFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
  title: string
}

export const LeadSourceFilter: FC<LeadSourceFilterProps> = props => (
  <CheckboxBasedFilter options={leadSourceFilterOptions} {...props} />
)
